import { LightType } from "../typings/light-type"
import { Vector3Dto } from "./vector3.dto"

export type LightConfigDto = BaseLightConfigDto | DirectionalLightConfigDto

export class BaseLightConfigDto {
  readonly name: string = ''
  readonly type: LightType = 'PointLight'
  readonly intensity: number = 1
  readonly color: number = 0xffffff
  readonly position?: Vector3Dto  
}

export class DirectionalLightConfigDto extends BaseLightConfigDto {  
  readonly target?: Vector3Dto  
  readonly type: LightType = 'DirectionalLight'
}

export function isDirectionalLightConfigDto(lightConfigDto: LightConfigDto): lightConfigDto is DirectionalLightConfigDto {
  return lightConfigDto.type === 'DirectionalLight'
}
